module.exports = __webpack_public_path__ + "static/media/noti-recomendada.15db933b.svg";